// @flow

import type { PropsSchema, BasicProps } from '../../type'
import * as React from 'react'
import computeData from '../hoc/computeData'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import type { Props as EasyCompProps } from '../EasyCompComponent'

type EasyCompElement = React.Element<React.ComponentType<EasyCompProps>>;
type Props = BasicProps & {
  text: string,
  children: React.ChildrenArray<EasyCompElement>
};

@computeData({ includeData: true })
export default class CopyText extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'textarea',
      key: 'text',
      title: '复制文本'
    },
    'separator',
    {
      type: 'event',
      title: '复制完成',
      event: 'copy'
    }
  ];

  onCopy = () => {
    const { callActions, text, jsEnv } = this.props
    const copyText = jsEnv.getString(text)
    callActions('copy', copyText)
  };

  render () {
    const { text, children, jsEnv } = this.props
    const copyText = jsEnv.getString(text)
    return (
      <CopyToClipboard onCopy={this.onCopy} text={copyText}>
        <span>{children}</span>
      </CopyToClipboard>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/CopyText.js